<div class="days-period d-flex align-center">
	<p>{{ 'exclude_weekends' | translate }}</p>
	<mat-slide-toggle
		[checked]="toggleValue"
		(change)="valueChanged.emit($event.checked)"
		color="primary"
	></mat-slide-toggle>
</div>
